export const CheckboxStyle = {
  baseStyle: {
    borderRadius: '4px',
    colorScheme: 'accent',
    iconColor: 'white',
    color: 'brand.text',
    borderColor: 'brand.border',
    paddingTop: 8,
    size: 'lg',
  },
  defaultProps: {
    borderRadius: '4px',
    colorScheme: 'accent',
    iconColor: 'white',
    color: 'brand.text',
    borderColor: 'brand.border',
    paddingTop: 8,
    size: 'lg',
  },
};
